<template>
  <div class="no-header h-full">
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
</style>
